export default {
    "d1c04679-43df-448c-91c4-b100217b5295":{
        "track_id" : "d1c04679-43df-448c-91c4-b100217b5295",
        "track_name" : "remedy",
        "cover_art" : "fwagnxmez2qc76la41gs",
        "artist_id" : "a502ff5e-e576-4363-82d8-618f19c37519",
        "artist_name" : "Crystal Clayton",
        "demo":{
            "uuid" : "1db3e671-2e1e-4d2c-8ed1-53b375778275",
            "in" : 89323,
            "out" : 119323
        },
        "media_id" : "04087832-0709-4866-aab7-7a0b566f14d8"
    },
    "823453bf-0c56-401e-89ef-63b28fd3efe8":{
        "track_id" : "823453bf-0c56-401e-89ef-63b28fd3efe8",
        "track_name" : "Top 5",
        "cover_art" : "gp3xh0p09fzmybqzxxxc",
        "artist_id" : "698e1d71-4f0d-4521-92bc-928c19017a1e",
        "artist_name" : "BoDee",
        "demo":{
            "uuid" : "80685fbb-a291-4c18-878c-02f59a5b8df2",
            "in" : 43000,
            "out" : 73000
        },
        "media_id" : "0ec68182-5c60-4fe8-9995-96e40bcf9ffa"
    },
    "53803c79-5a9e-4d17-84e3-e0f5565aef65":{
        "track_id" : "53803c79-5a9e-4d17-84e3-e0f5565aef65",
        "track_name" : "Rush Hour",
        "cover_art" : "mpvmfqjcdedexrivl6ah",
        "artist_id" : "e971f53b-94ac-4de0-af3a-cd044a8b04c1",
        "artist_name" : "JALENHERO",
        "demo":{
            "uuid" : "3a5e322e-6609-4a6a-9fbe-5b44c26d56e0",
            "in" : 128964,
            "out" : 158964
        },
        "media_id" : "2dafb930-c86e-4662-83ef-60eb85ec1b89"
    },
    "01725cf5-07bf-47c8-9584-46e3d8c1d292":{
        "track_id" : "01725cf5-07bf-47c8-9584-46e3d8c1d292",
        "track_name" : "Good Vibes",
        "cover_art" : "xcq4pt8mcjipocoxy2q0",
        "artist_id" : "821b78a8-fd0d-4480-a0ac-c881aa52a5f6",
        "artist_name" : "Lafam 360",
        "demo":{
            "uuid" : "acf75465-ba2f-4e58-82ec-b11388908c43",
            "in" : 55339,
            "out" : 85339
        },
        "media_id" : "5da308e5-cb68-4579-a0e1-2b0cfa451289"
    },
    "84402b69-c3a4-4751-8c2b-7e1baa65383a":{
        "track_id" : "84402b69-c3a4-4751-8c2b-7e1baa65383a",
        "track_name" : "The Truth",
        "cover_art" : "dgbuijgzdqk0aadhexdt",
        "artist_id" : "3ac9532c-892a-428b-8205-2247572d6af0",
        "artist_name" : "Stiff Lauren",
        "demo":{
            "uuid" : "55885541-b219-4bf3-9676-d95a0aaf5e3c",
            "in" : 9921,
            "out" : 39921
        },
        "media_id" : "b91b98f8-4a81-41e3-8a66-c777f42f7b93"
    },
    "7f32fbde-5ab0-4357-92da-ad825c5fb162":{
        "track_id" : "7f32fbde-5ab0-4357-92da-ad825c5fb162",
        "track_name" : "Lullaby",
        "cover_art" : "ldmucnb9clm0kofexr6k",
        "artist_id" : "89a4604d-a263-4553-8b2e-93d8fc8275db",
        "artist_name" : "Ken Xanny",
        "demo":{
            "uuid" : "0b74e575-5a21-4354-b0d6-0965d5b5f899",
            "in" : 30369,
            "out" : 60369
        },
        "media_id" : "c9efb01b-0304-4300-ba3a-f01f7af9358d"
    },
    "b298f986-b70a-4ff9-b333-02573d6892ce":{
        "track_id" : "b298f986-b70a-4ff9-b333-02573d6892ce",
        "track_name" : "1224 Huncho’Noon - Dallas, Texas",
        "cover_art" : "eqze2cfb6nmu8hauwggy",
        "artist_id" : "b1d4f4da-b728-4bff-9647-40333b713bac",
        "artist_name" : "1224 Huncho’Noon",
        "demo":{
            "uuid" : "ee5828f6-b526-494f-8b40-d24a21a47d7b",
            "in" : 14033,
            "out" : 44033
        },
        "media_id" : "ceb773c6-f33e-451a-b787-30185a0e0b25"
    },
    "f4b898d6-8afb-4f3e-b2e6-763861b28065":{
        "track_id" : "f4b898d6-8afb-4f3e-b2e6-763861b28065",
        "track_name" : "Str8",
        "cover_art" : "kt5oocgz14oyaxdelzqr",
        "artist_id" : "821b78a8-fd0d-4480-a0ac-c881aa52a5f6",
        "artist_name" : "Lafam 360",
        "demo":{
            "uuid" : "021a75d8-4d70-424e-af94-e8cc93ae4c95",
            "in" : 49592,
            "out" : 79592
        },
        "media_id" : "dacb69bc-e357-4f0c-9ff4-110a5e40e8fa"
    },
    "2f0b1014-15b7-4cda-a6d0-8c2d44d0a986":{
        "track_id" : "2f0b1014-15b7-4cda-a6d0-8c2d44d0a986",
        "track_name" : "Last Minute",
        "cover_art" : "znhecjezkaqp0knfrx6k",
        "artist_id" : "698e1d71-4f0d-4521-92bc-928c19017a1e",
        "artist_name" : "BoDee",
        "demo":{
            "uuid" : "e6b05a00-4ed3-42a4-9605-0b6ea728c462",
            "in" : 16117,
            "out" : 46117
        },
        "media_id" : "dc5e23a1-682d-43a7-ade3-484983b7b8e6"
    },
    "cb9a1066-43d1-429f-ab60-8486e505a628":{
        "track_id" : "cb9a1066-43d1-429f-ab60-8486e505a628",
        "track_name" : "How I Do It",
        "cover_art" : "qnngxhppt9nmodncyzti",
        "artist_id" : "1540e76a-1635-40f9-9dc1-0b0009456c9c",
        "artist_name" : "LALovetheboss",
        "demo":{
            "uuid" : "c8e7c497-1fcd-40d8-93cb-45e1138de758",
            "in" : 85110,
            "out" : 115110
        },
        "media_id" : "f8ff3e29-f296-49a5-83c0-1d12cfc29462"
    }
}
